import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import "rxjs/add/operator/map";
import { environment } from "src/environments/environment";
import { content } from "html2canvas/dist/types/css/property-descriptors/content";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class EmployeesService {
  constructor(private httpClient: HttpClient) { }
  getEMployeesByID(employeeID, keyword) {
     console.log("Employee number: " +employeeID);
    return this.httpClient
      .get(environment.api.Employees_LAMBDA_V1 + "/" + employeeID, {
        params: {
          keyword: keyword,
        },
      }).pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getAllEmployee(employeeID, keyword) {
     console.log("Employee number: " +employeeID);
    return this.httpClient
      .get(environment.api.employeeTrx + "/" + employeeID, {
        params: {
          keyword: keyword,
        },
      }).pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getEMployeesByIDV1(employeeID: number, keyword: string): Observable<any> {
  return this.httpClient
    .get(environment.api.Employees_LAMBDA_V1 + "/" + employeeID, {
      params: { keyword: keyword },
    })
    .pipe(
      map((data) => data) // ← opcional si no transformas
    );
}
getEMployeeLogin(employee_id: number, keyword: any): Observable<any> {
  console.log("Employee number: " + employee_id);
  const url = environment.api.Employees_LAMBDA_V1 + "/" + employee_id + "?keyword=" + keyword;
  console.log("url", url)
  return this.httpClient
    .get(url)
    .map((data) => {
      console.log(data);
      return data;
    });
}

// Llamar a la función y suscribirse al observable

  getUserForEmployee(employee_id) {
    //https://q6sq29b6ic.execute-api.us-east-2.amazonaws.com/ema-admin/v1/employee/user
    //

    return this.httpClient
      .get(environment.api.employeeUserData, {
        params: {
          employee_number: employee_id,
        },
      })
       .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  upsertEmployee(data) {
    return this.httpClient
      .post(environment.api.upseremployee, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getDriverLicense(employeeID, licenses_id) {
    return this.httpClient
      .get(environment.api.driverLicenses + "/" + licenses_id, {
        params: {
          employee_id: employeeID,
        },
      })
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  upsertDriverLicense(data) {
    return this.httpClient
      .post(environment.api.driverLicenses, data)
       .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getDocumentEmployees(employeeID) {
    return this.httpClient
      .get(environment.api.documentEmployees, {
        params: {
          employee_id: employeeID,
        },
      })
  .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  upsertDocument(data) {
    return this.httpClient
      .post(environment.api.documentEmployees, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

 updateInactiveUser(data) {
    return this.httpClient
      .put(environment.api.inactiveUser, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  /*
  AMH  23 02  2024
  Esta función ya no se utiliza y por lo tanto el endpoint en environment tampoco
  */
  /* obtenerEmpleados_DEPRECATED(employeeID, rs) {
     return this.httpClient
       .get(environment.api.employeesGet + employeeID)
       .map((data) => data);
   }*/
  obtenerEmpleado(employeeID) {
    return this.httpClient
      .get(
        environment.api.Employees_LAMBDA_V1 +
        "/" /*'http://adec-authorization.us-east-2.elasticbeanstalk.com/v1/ema-system/employees/'*/ +
        employeeID,
        {
          params: {
            keyword: null,
          },
        }
      )
      .map((data) => data);
  } /////////


  getEmplooyeeContact(employeeID) {
    return this.httpClient
      .get(environment.api.employeesContacts, {
        params: {
          employee_id: employeeID,
        },
      })
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  addEmployeeContact(data) {
    return this.httpClient
      .post(environment.api.employeesContacts, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  updateEmployeeContact(data) {
    return this.httpClient
      .put(environment.api.employeesContacts, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  deleteEmployeeContact(employeeContact_id) {
    return this.httpClient
      .delete(environment.api.employeesContacts + "/" + employeeContact_id)
     .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getEmplooyeeMedical(employeeID) {
    return this.httpClient
      .get(environment.api.employeesMedical, {
        params: {
          employee_id: employeeID,
        },
      })
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  addEmployeeMedical(data) {
    return this.httpClient
      .post(environment.api.employeesMedical, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  updateEmployeeMedical(data) {
    return this.httpClient
      .put(environment.api.employeesMedical, data)
       .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  getWorkTool(equipment_id) {
    return this.httpClient
      .get(environment.api.work_tools + "/" + equipment_id,)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  getWorkToolview(keyword) {
    return this.httpClient
      .get(environment.api.work_tools+"/view", {
        params: {
          keyword: keyword
        }
      })
     .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  addWorkTool(data) {
    return this.httpClient
      .post(environment.api.work_tools, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  updateWorkTool(data) {
    return this.httpClient
      .put(environment.api.work_tools, data)
       .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  getIncidents(incident_id,employee_id) {
    return this.httpClient
      .get(environment.api.incidents + "/" + incident_id,{
        params:{
          employee_id:employee_id
        }
      })
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  getviewIncidents(data) {
    return this.httpClient
      .post(environment.api.incidents+"/view",data
      )
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

  addIncidents(data) {
    return this.httpClient
      .post(environment.api.incidents, data)
       .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }
  updateIncidents(data) {
    return this.httpClient
      .put(environment.api.incidents, data)
      .pipe(
      map((data) => data) // ← opcional si no transformas
    );
  }

}
